@import "./../../less/variables.less";

.doneContainer {
  margin-top: var(--dds-spacing-medium-40);
}
.doneContainer > * {
  margin-left: auto;
  margin-right: auto;
  display: block;
  text-align: center;
}

.doneContainer > img {
  margin-bottom: var(--dds-spacing-large-48);
}
.doneContainer > h1 {
  margin-bottom: var(--dds-spacing-medium-32);
}
.illustration {
  width: 20%;
}
